/* eslint-disable react-hooks/exhaustive-deps */
import i18next from 'i18next';
import { Scatter } from '@antv/g2plot';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import Widget from '../../widget';
import Header from '../../components/scl-components/header';
import Legend from '../../components/scl-components/legend';
import { filterData, getColors, getLegend, Tooltip } from './config';

const Style = styled.div`
  flex: 1;
  justify-content: space-between;
  gap: 20px;

  .chart {
    height: 400px;
  }

  .custom-tooltip {
    padding: 12px 0px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .tooltip-header {
      h1 {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 6px;
        color: #001529;
      }

      p {
        font-size: 12px;
        font-weight: 500;
        color: #001529;
        margin-bottom: 0px;
        font-weight: 300;

        &.is-link {
          margin-bottom: 6px;
          color: var(--mmt-primary-70);
          font-weight: 500;
        }
      }
    }

    .score {
      display: flex;
      gap: 10px;

      h3 {
        margin-bottom: 0px;
        font-size: 13px;
        font-weight: 500;
        color: #001529;
        flex: 1;
      }

      .hexagons {
        display: flex;
        gap: 4px;
      }

      label {
        margin-bottom: 0px;
        font-size: 13px;
        font-weight: 500;
        color: #001529;
      }
    }
  }
`;

const RiskMaterialisation = ({
  data = [],
  isOwnData = false,
  loading,
}) => {
  const { t } = useTranslation();
  const [graph, setGraph] = useState();
  const container = useRef();
  const [legend, setLegend] = useState();

  useEffect(() => {
    setLegend((getLegend(i18next.language)));
  }, [i18next.language]);

  useEffect(() => {
    if (legend && data) {
      const filtered = filterData(data, legend.filter((l) => l.toggled).map((l) => l.key));
      const color = getColors(filtered);
      if (graph) {
        graph.update({
          data: filtered,
          color,
          tooltip: {
            customContent: (_, data) => {
              if (data && data[0]);
              return Tooltip(data[0], t);
            }
          },
        });
      } else {
        const scatterPlot = new Scatter(container.current, {
          appendPadding: 30,
          data: filtered,
          xField: 'impact',
          yField: 'threat',
          colorField: 'type',
          color,
          sizeField: 'incidents',
          size: [5, 20],
          shape: 'circle',
          yAxis: {
            nice: true,
            line: {
              style: {
                stroke: '#eee',
              },
            },
            tickMethod: () => [0, 1, 2, 3, 4, 5],
            label: {
              formatter: (val) => `${val}`,
            },
          },
          xAxis: {
            grid: {
              line: {
                style: {
                  stroke: '#eee',
                },
              },
            },
            tickMethod: () => [0, 1, 2, 3, 4, 5],
            label: {
              formatter: (val) => val !== '0' ? `${val}` : ' ',
            },
            line: {
              style: {
                stroke: '#eee',
              },
            },
          },
          tooltip: {
            showCrosshairs: false,
            customContent: (_, data) => {
              if (data && data[0]);
              return Tooltip(data[0]);
            }
          },
          legend: false,
        });
        scatterPlot.render();
        setGraph(scatterPlot)
      }
    }
  }, [data, legend]);

  const toggle = (item) => {
    setLegend((prev) => prev.map((p) => {
      if (p.key === item.key) {
        return { ...item, toggled: !item.toggled };
      }
      return p;
    }));
  };

  return (
    <Widget
      title={t('Risk Materialisation')}
      tooltip={t('Analysis of the frequency of reported incidents against components of the risk assessment for this location')}
      loading={loading}
      header={
        <Header
          legend='RISK_MATERIALISATION'
          t={t}
        />
      }
      className="full-header custom-width-c with-border-header no-pt-body"
    >
      <Style>
        <div className="chart" ref={container} />
        <Legend
          legend={legend}
          toggle={toggle}
          setLegend={setLegend}
          className={isOwnData ? "risk-materialisation" : null}
          groupBy={!isOwnData ? 3 : null}
        />
      </Style>
    </Widget>
  );
}

export default RiskMaterialisation;
